import { Anchor, Box, Container, Group, Stack, Text } from '@mantine/core'
import { Link } from 'react-router-dom'
import GunSlopWordmark from './GunSlopWordmark'

export default function SiteLegalFooter () {
  const year = new Date().getFullYear()

  return (
    <Box
      component="footer"
      sx={{
        padding: '40px 20px 48px',
        background: 'var(--gs-bg)',
        borderTop: '1px solid var(--gs-border)'
      }}
    >
      <Container size="sm">
        <Stack spacing="md" align="center">
          <Group spacing="lg" position="center">
            <Anchor component={Link} to="/terms" size="xs" sx={{ color: 'var(--gs-muted)' }}>
              Terms of Service
            </Anchor>
            <Anchor component={Link} to="/privacy" size="xs" sx={{ color: 'var(--gs-muted)' }}>
              Privacy Policy
            </Anchor>
            <Anchor component={Link} to="/guidelines" size="xs" sx={{ color: 'var(--gs-muted)' }}>
              Community Guidelines
            </Anchor>
          </Group>
          <Text
            sx={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 12,
              fontWeight: 600,
              color: 'var(--gs-text)',
              textAlign: 'center',
              letterSpacing: 0.2
            }}
          >
            © {year}{' '}
            <GunSlopWordmark size="xs" inline sx={{ color: 'var(--gs-text)' }} />
            . All rights reserved.
          </Text>
          <Text
            sx={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 11,
              color: 'var(--gs-muted)',
              textAlign: 'center',
              lineHeight: 1.65,
              maxWidth: 520
            }}
          >
            The GunSlop website, branding, logos, and original platform materials are protected by copyright,
            trademark, and other intellectual property laws. Unauthorized copying, modification, or distribution
            is prohibited except as permitted in writing or by applicable law.
          </Text>
          <Text
            sx={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 11,
              color: 'var(--gs-muted)',
              textAlign: 'center',
              lineHeight: 1.65,
              maxWidth: 520
            }}
          >
            Content on this site is provided for general informational and community purposes only and does not
            constitute legal, regulatory, safety, or professional advice. Your use of the site and any
            information or materials is at your own risk. You are solely responsible for complying with all
            applicable federal, state, and local laws and for following safe practices.
          </Text>
        </Stack>
      </Container>
    </Box>
  )
}
